import axios from './axiosInstance'
import constants from '../constants'

export default function init() {
  console.log('analytics init')
}

export async function getByType(app, appSettings, type, params) {
  let URL = constants.isLiveEnv || constants.isStagingEnv ? 'https://' : 'http://'
  if (type === 'dau' || type === 'mau' || type === 'hau')
    URL = `${URL}${appSettings}/v2/${type}/range/${params.startRange}/${params.endRange}`
  else if (type === 'ccu')
    URL = `${URL}${appSettings}/v1/${type}/range/${params.startRange}/${params.endRange}`
  else if (type === 'pcu')
    URL = `${URL}${appSettings}/v1/ccupeaks/?beginningTimestamp=${params.startRange}&endingTimestamp=${params.endRange}`
  else if (type === 'voice' || type === 'video')
    URL = `${URL}${appSettings}/v1/calls/statistics?beginningTimestamp=${params.startRange}&endingTimestamp=${params.endRange}&interval=day`

  return axios
    .get(`${URL}`, {
      timeout: constants.timeout_in_ms.metrics,
      headers: {
        appId: app.id,
        Authorization: `Bearer ${app.statsToken}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      let err = {
        err_code: 'ERR',
        err_message:
          'We encountered an error. Please refresh your page and try again. Contact us if error persists.',
      }
      if (error.code !== undefined && error.code === 'ECONNABORTED') {
        err = {
          err_code: 'ECONNABORTED',
          err_message:
            'A request timeout occured. Please refresh your page and try again. Contact us if error persists.',
        }
      }

      return err
    })
}

export async function get(
  app,
  appSettings,
  dauCall,
  mauCall,
  ccuCall,
  peakCcuCall,
  voiceVideoCall,
) {
  const URL = constants.isLiveEnv || constants.isStagingEnv ? 'https://' : 'http://'
  const one = `${URL}${appSettings}/v2/${dauCall.type}/range/${dauCall.startRange}/${dauCall.endRange}`
  const two = `${URL}${appSettings}/v2/${mauCall.type}/range/${mauCall.startRange}/${mauCall.endRange}`
  const three = `${URL}${appSettings}/v1/${ccuCall.type}/range/${ccuCall.startRange}/${ccuCall.endRange}`
  const four = `${URL}${appSettings}/v1/ccupeaks/?beginningTimestamp=${peakCcuCall.startRange}&endingTimestamp=${peakCcuCall.endRange}`
  // const five = `${URL}metrics-${app.region}.${constants.analyticsDomainV1}pie?filters=version,platform`
  const five = `${URL}${appSettings}/v1/calls/statistics?beginningTimestamp=${voiceVideoCall.startRange}&endingTimestamp=${voiceVideoCall.endRange}&interval=day`

  const requestOne = axios.get(`${one}`, {
    timeout: constants.timeout_in_ms.metrics,
    headers: {
      appId: app.id,
      Authorization: `Bearer ${app.statsToken}`,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
  const requestTwo = axios.get(`${two}`, {
    timeout: constants.timeout_in_ms.metrics,
    headers: {
      appId: app.id,
      Authorization: `Bearer ${app.statsToken}`,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
  const requestThree = axios.get(`${three}`, {
    timeout: constants.timeout_in_ms.metrics,
    headers: {
      appId: app.id,
      Authorization: `Bearer ${app.statsToken}`,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })

  const requestFour = axios.get(`${four}`, {
    timeout: constants.timeout_in_ms.metrics,
    headers: {
      appId: app.id,
      Authorization: `Bearer ${app.statsToken}`,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })

  // const requestSix = axios.get(`${six}`, {
  //   timeout: constants.timeout_in_ms.metrics,
  //   headers: {
  //     appId: app.id,
  //     Authorization: `Bearer ${app.statsToken}`,
  //     'Content-Type': 'application/json',
  //     Accept: 'application/json',
  //   },
  // })

  const requestFive = axios.get(`${five}`, {
    timeout: constants.timeout_in_ms.metrics,
    headers: {
      appId: app.id,
      Authorization: `Bearer ${app.statsToken}`,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })

  const structuredResponse = {
    dau: [],
    mau: [],
    ccu: [],
    peakCcu: [],
    // platformVersion: [],
    voiceVideo: [],
    metricSuccess: true,
  }
  return axios
    .all([requestOne, requestTwo, requestThree, requestFour, requestFive], {
      // requestSix,
      timeout: constants.timeout_in_ms.metrics,
      headers: {
        appId: app.id,
        Authorization: `Bearer ${app.statsToken}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(
      axios.spread((...responses) => {
        structuredResponse.dau = responses[0].data
        structuredResponse.mau = responses[1].data
        structuredResponse.ccu = responses[2].data
        structuredResponse.peakCcu = responses[3].data
        structuredResponse.voiceVideo = responses[4].data
        // structuredResponse.platformVersion = responses[4].data
        structuredResponse.metricSuccess = true
        return structuredResponse
      }),
    )
    .catch(error => {
      let err = {
        err_code: 'ERR',
        err_message:
          'We encountered an error. Please refresh your page and try again. Contact us if error persists.',
      }
      if (error.code !== undefined && error.code === 'ECONNABORTED') {
        err = {
          err_code: 'ECONNABORTED',
          err_message:
            'A request timeout occured. Please refresh your page and try again. Contact us if error persists.',
        }
      }

      return err
    })
}

export async function getPeak(app, startRange, endRange) {
  let URL = constants.isLiveEnv || constants.isStagingEnv ? 'https://' : 'http://'
  URL = `${URL}metrics-${app.region}.${constants.analyticsDomainV1}ccupeaks/?beginningTimestamp=${startRange}&endingTimestamp=${endRange}`
  return axios
    .get(`${URL}`, {
      timeout: constants.timeout_in_ms.metrics,
      headers: {
        appId: app.id,
        Authorization: `Bearer ${app.statsToken}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      let err = {
        err_code: 'ERR',
        err_message:
          'We encountered an error. Please refresh your page and try again. Contact us if error persists.',
      }
      if (error.code !== undefined && error.code === 'ECONNABORTED') {
        err = {
          err_code: 'ECONNABORTED',
          err_message:
            'A request timeout occured. Please refresh your page and try again. Contact us if error persists.',
        }
      }

      return err
    })
}

export async function getPlatformVersion(app) {
  let URL = constants.isLiveEnv || constants.isStagingEnv ? 'https://' : 'http://'
  URL = `${URL}metrics-${app.region}.${constants.analyticsDomainV1}pie?filters=version,platform`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        Authorization: `Bearer ${app.statsToken}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      let err = false
      if (error.response !== undefined && error.response.data !== undefined)
        err = error.response.data

      return err
    })
}

export async function getVoiceAndVideo(app, startRange, endRange) {
  let URL = constants.isLiveEnv || constants.isStagingEnv ? 'https://' : 'http://'
  URL = `${URL}metrics-${app.region}.${constants.analyticsDomainV1}calls/statistics?beginningTimestamp=${startRange}&endingTimestamp=${endRange}&interval=day`
  return axios
    .get(`${URL}`, {
      timeout: constants.timeout_in_ms.metrics,
      headers: {
        appId: app.id,
        Authorization: `Bearer ${app.statsToken}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      let err = {
        err_code: 'ERR',
        err_message:
          'We encountered an error. Please refresh your page and try again. Contact us if error persists.',
      }
      if (error.code !== undefined && error.code === 'ECONNABORTED') {
        err = {
          err_code: 'ECONNABORTED',
          err_message:
            'A request timeout occured. Please refresh your page and try again. Contact us if error persists.',
        }
      }

      return err
    })
}

export async function getBillingCycleUsage(app, analyticsHost) {
  let URL = constants.isLiveEnv || constants.isStagingEnv ? 'https://' : 'http://';
  if (app.isAnnual) {
    URL = `${URL}${analyticsHost}/v2/dashboard/billing/${app.monthlyTermStart * 1000}/${app.monthlyTermEnd * 1000}`
  } else {
    URL = `${URL}${analyticsHost}/v2/dashboard/billing/${app.currentTermStart * 1000}/${app.currentTermEnd * 1000}`
  }
  return axios
    .post(
      `${URL}`,
      { appIds: [app.id] },
      {
        timeout: constants.timeout_in_ms.metrics,
        headers: {
          appId: app.id,
          Authorization: `Bearer ${app.statsToken}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      },
    )
    .then(res => {
      return res.data
    })
    .catch(error => {
      let err = {
        err_code: 'ERR',
        err_message:
          'We encountered an error. Please refresh your page and try again. Contact us if error persists.',
      }
      if (error.code !== undefined && error.code === 'ECONNABORTED') {
        err = {
          err_code: 'ECONNABORTED',
          err_message:
            'A request timeout occured. Please refresh your page and try again. Contact us if error persists.',
        }
      }

      return err
    })
}

export async function getInsightsData(URL) {
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    let errorObject = error
    if (error.response !== undefined && error.response.data !== undefined)
      errorObject = error.response.data

    return errorObject
  }
  return false
}
